<template>
    <v-app-bar app id="main-top-bar" :style="user.isBirthday() ? 'background-image: url(' + baseUrl + 'img/birthday_flags.png)' : ''">

        <v-app-bar-nav-icon @click.stop="$emit('navBarChange');"></v-app-bar-nav-icon>

        <Counters class="d-none d-md-flex"/>
        <div class="d-none d-md-flex">
            <SearchPrice/>
        </div>

        <v-spacer></v-spacer>

        <QuickSearch/>

        <v-spacer></v-spacer>

        <SocketStatus/>
        <PhoneCallDialer/>

        <v-menu offset-y eager>
            <template v-slot:activator="{ on, attrs }">
                <v-btn fab v-bind="attrs" v-on="on" small color="secondary" depressed class="ml-4">
                    <Avatar :user="user" />
                </v-btn>
            </template>
            <v-list>
                <v-subheader>{{ userName }}</v-subheader>
                <dark-mode/>
                <ThemeColorPicker/>
                <v-list-item :to="'/profile'">
                    <v-list-item-action>
                        <v-icon>mdi-account</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Profiel</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :href="VUE_APP_BO_URL + '/logout'">
                    <v-list-item-action>
                        <v-icon>mdi-exit-to-app</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Uitloggen</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import User from "@/models/User/User";
import QuickSearch from "@/components/QuickSearch";
import Counters from "@/components/Layout/Partials/Counters";
import DarkMode from "@/components/Layout/Partials/theme/DarkMode";
import PhoneCallDialer from "@/components/PhoneCall/Dialer";
import ThemeColorPicker from "@/components/Layout/Partials/theme/ColorPicker";
import SearchPrice from "@/components/Package/SearchPrice";
import Avatar from "@/components/User/Avatar";
import SocketStatus from "@/components/Layout/Partials/SocketStatus.vue";

export default {
    components: {
        SocketStatus,
        ThemeColorPicker,
        SearchPrice,
        PhoneCallDialer,
        DarkMode,
        QuickSearch,
        Counters,
        Avatar
    },
    data() {
        return {
            baseUrl: window.config.BASE_URL,
            VUE_APP_BO_URL: window.config.BACKOFFICE_URL,
        }
    },
    computed: {
        userName() {
            return User.loggedInUser().name;
        },
        user() {
            return User.loggedInUser();
        }
    },
}
</script>
